import React, { useState } from "react"
import { useParams } from "react-router-dom"

import SEO from "../../components/Common/SEO"
import { PAGE_SEO } from "../../config/seoConfig"
import { generateCanonicalUrl } from "../../utils/seoUtils"

import InfluencerProfileSection from "./components/InfluencerProfileSection"

/**
 * The Influencer Explorer's profile detail screen - a real route
 * (`/influencer-explorer/:platform/:username`) rather than an in-page panel
 * swap, since a creator profile (INFLUENCER_PROFILE_API.md) is meant to be
 * shareable/bookmarkable, unlike UGC Explorer's ephemeral video detail view.
 * Mirrors InfluencerExplorer.jsx's own page-shell shape: `<SEO/>` + a
 * `container-fluid` wrapper: the actual content lives in
 * InfluencerProfileSection.
 */
const InfluencerProfile = () => {
    const { platform, username } = useParams()
    // Swapped in once the profile loads, via InfluencerProfileSection's
    // onTitleReady - falls back to the static PAGE_SEO entry (and a
    // generic route-based title) until then.
    const [creatorTitle, setCreatorTitle] = useState(null)

    const seoTitle = creatorTitle
        ? `${creatorTitle} | Influencer Explorer`
        : PAGE_SEO.influencerProfile.title

    return (
        <React.Fragment>
            <SEO
                title={seoTitle}
                description={PAGE_SEO.influencerProfile.description}
                keywords={PAGE_SEO.influencerProfile.keywords}
                canonical={generateCanonicalUrl(`/influencer-explorer/${platform}/${username}`)}
                robots={PAGE_SEO.influencerProfile.robots}
            />

            <div className="page-content">
                <div className="container-fluid" style={{ fontFamily: "Rubik, sans-serif" }}>
                    <InfluencerProfileSection
                        onTitleReady={(name, platformLabel) => {
                            setCreatorTitle(platformLabel ? `${name} (${platformLabel})` : name)
                        }}
                    />
                </div>
            </div>
        </React.Fragment>
    )
}

export default InfluencerProfile
